"use client"
// src/blocks/link/link.tsx
import { sendGAEvent } from "@next/third-parties/google";
import NextLink from "next/link";
import { jsx } from "react/jsx-runtime";
var Link = ({
  children,
  className,
  href,
  id,
  openNewTab,
  target,
  title,
  tracking,
  ...rest
}) => {
  if (!(children && href)) return null;
  const urlRegEx = RegExp(
    /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)/gi
  );
  const isExternal = openNewTab || urlRegEx.test(href.toString());
  if (isExternal)
    return /* @__PURE__ */ jsx(
      "a",
      {
        className: `${className}`,
        href: href.toString(),
        id,
        rel: "noreferrer noopener",
        target: "_blank",
        title,
        onClick: () => {
          sendGAEvent("event", "linkInteraction", {
            value: `${tracking?.module}|${tracking?.layout}|${tracking?.component}|${tracking?.label}|`
          });
        },
        ...rest,
        children
      }
    );
  return /* @__PURE__ */ jsx(
    NextLink,
    {
      className,
      href: href.toString().startsWith("/") ? href : `/${href.toString()}`,
      id,
      onClick: () => {
        sendGAEvent("event", "linkInteraction", {
          value: `${tracking?.module}|${tracking?.layout}|${tracking?.component}|${tracking?.label}|`
        });
      },
      title,
      ...rest,
      children
    }
  );
};
var link_default = Link;

export {
  link_default
};
